/**
 * Simple js to isolate retrieve of complex variables.
 * This way components requiring those variables are not aware where they are comming from and possible complexity involved
 */
const lexVersion = require('../../package.json').version;

export {
    lexVersion
};
